import clsx from "clsx";

export const DEFAULT_ROWS_PER_PAGE = 10;
export const DEFAULT_ROWS_PER_PAGE_OPTIONS = [10, 25, 50, 100] as const;
export const commonClasses = (isCompact: boolean | undefined) =>
  clsx(
    "text-gray-900",
    "forced-colors:border-[ButtonText]",
    "forced-colors:text-[ButtonText]",
    "forced-colors:data-[focus=true]:outline-solid!",
    "forced-colors:data-[focus=true]:outline-2!",
    "forced-colors:data-[focus=true]:outline-[ButtonText]!",
    {
      "bg-gray-100 data-[focus=true]:-outline-offset-2": isCompact,
      "border border-gray-500 bg-white data-[focus=true]:outline-offset-1":
        !isCompact,
      "data-[focus=true]:data-[active=true]:outline-offset-1": isCompact,
      "forced-colors:bg-[GrayText]!": isCompact,
    },
  );
